import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";

export const Landing: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="onboard-landing-page flex flex-col items-center">
      <div className="my-8 text-xl font-bold">Welcome to Control Plane</div>
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="text-center">Start Using Control Plane by Creating an Account</div>
        <Button type="primary" className="action" onClick={() => navigate("/home/account/-create")}>
          Create Account
        </Button>
      </div>
    </div>
  );
};
